import { TravellerFieldEnum } from '@websky/graphql';
import { capitalizeFirstLetter, concatPassengerNames, getUserValue } from '../../../../utils';
export function createInitialOrderTravellers(travellers) {
    return travellers.reduce((acc, traveller) => {
        const travellerId = traveller.id;
        const firstName = capitalizeFirstLetter(getUserValue(traveller, TravellerFieldEnum.FirstName));
        const lastName = capitalizeFirstLetter(getUserValue(traveller, TravellerFieldEnum.LastName));
        const middleName = capitalizeFirstLetter(getUserValue(traveller, TravellerFieldEnum.MiddleName));
        const fullName = concatPassengerNames({ firstName, lastName });
        const loyaltyNumber = getUserValue(traveller, TravellerFieldEnum.LoyaltyNumber);
        acc[travellerId] = {
            id: travellerId,
            values: {
                firstName,
                lastName,
                middleName,
                fullName,
                loyaltyNumber
            }
        };
        return acc;
    }, {});
}
